import React from "react";
import { Link } from "react-router-dom";
import "./Home.css";

const Home = () => {
  return (
    <div className="home-wrapper">
      <section className="hero-modern software-hero">
        <div className="hero-bg-soft"></div>

        <div className="hero-left">
          <span className="hero-eyebrow">
            SOFTWARE • CLOUD • AUTOMATION • DIGITAL SIGNAGE
          </span>

          <h1 className="hero-title">
            Enterprise <span>software</span>
            <br />
            built for growth,
            <br />
            automation & visibility
          </h1>

          <p className="hero-subtext">
            Pryce Technologies develops enterprise-grade software platforms,
            cloud applications, network monitoring systems, digital signage
            solutions, IoT monitoring platforms and custom business software
            that help organisations scale with confidence.
          </p>

          <div className="hero-buttons">
            <Link to="/services" className="primary-btn">
              Explore Services
            </Link>

            <Link to="/products" className="secondary-btn">
              View Products
            </Link>
          </div>
        </div>

        <div className="hero-right">
          <div className="hero-visual-card">
            <div className="hero-visual-topbar">
              <span></span>
              <span></span>
              <span></span>
            </div>

            <div className="hero-dashboard">
              <div className="dashboard-sidebar">
                <div className="sidebar-logo"></div>
                <div className="sidebar-line"></div>
                <div className="sidebar-line"></div>
                <div className="sidebar-line short"></div>
                <div className="sidebar-line"></div>
                <div className="sidebar-line short"></div>
              </div>

              <div className="dashboard-main">
                <div className="dashboard-header">
                  <div className="dashboard-search"></div>
                  <div className="dashboard-avatar"></div>
                </div>

                <div className="dashboard-cards">
                  <div className="mini-card">
                    <div className="mini-title"></div>
                    <div className="mini-value wide"></div>

                    <div className="mini-chart bars">
                      <span></span>
                      <span></span>
                      <span></span>
                      <span></span>
                    </div>
                  </div>

                  <div className="mini-card">
                    <div className="mini-title"></div>
                    <div className="mini-value"></div>
                    <div className="mini-chart line"></div>
                  </div>
                </div>

                <div className="table-card">
                  <div className="table-header">
                    <div className="table-title"></div>
                    <div className="table-pill"></div>
                  </div>

                  <div className="table-grid">
                    {[1,2,3,4,5].map((i) => (
                      <div key={i} className="table-row">
                        <span></span>
                        <span></span>
                        <span></span>
                        <span></span>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="hero-blob"></div>
        </div>
      </section>

      <section className="stats-strip">
        <div className="stat-item">
          <h3>Custom Software</h3>
          <p>
            Bespoke web, mobile and desktop platforms tailored to business
            operations.
          </p>
        </div>

        <div className="stat-item">
          <h3>Cloud Infrastructure</h3>
          <p>
            Secure AWS cloud deployments and enterprise hosting environments.
          </p>
        </div>

        <div className="stat-item">
          <h3>Digital Solutions</h3>
          <p>
            Digital signage, IoT monitoring, analytics and automation systems.
          </p>
        </div>
      </section>
    </div>
  );
};

export default Home;